import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_iuf_select = _resolveComponent("iuf-select")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    title: _ctx.t('UPDATE_ASSET_CLASSIFICATION', { asset: _ctx.leadTypeLabel.toLowerCase() }),
    onConfirm: _ctx.validateAndSubmit,
    onCancel: _ctx.cancel,
    loading: _ctx.loading,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "q-pa-lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            greedy: "",
            id: "asset-edition-form",
            ref: "assetEditionForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_input, _mergeProps(_ctx.INPUT_LG, {
                readonly: "",
                "label-slot": "",
                label: _ctx.t('NAME'),
                modelValue: _ctx.companyName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyName) = $event))
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('NAME_TOOLTIP')), 1)
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }, 16, ["label", "modelValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.areasOfInterest,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.areasOfInterest) = $event)),
                "max-values": 5,
                label: _ctx.t('AREAS_OF_INTEREST'),
                options: _ctx.areasOfInterestOptions
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                "allow-create": _ctx.canCreateAreaOfInterest && _ctx.isAllowedToCreate,
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                "option-label": "label",
                onFilter: _ctx.filterAreasOfInterestOptions,
                "selected-item-slot": "",
                onCreateValue: _ctx.createAreaOfInterest
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "allow-create", "placeholder-value", "onFilter", "onCreateValue"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "onConfirm", "onCancel", "loading"]))
}